<template>
    <div id="home-screen-index" class="m-auto h-screen-calc overflow-y-scroll">
        <div id='block-search' v-if="$root.hotelCode == 'miracleon'">
            <div id='tl-search-form' class='tl-container'>
                <a href='https://www.travelline.ru/products/tl-hotel/' target='_blank'></a>
            </div>
        </div>

        <div class="flex-grow flex flex-col relative wrapper">
            <div id="main-screen-index" class="relative flex-none w-full h-screen-calc">
                <video v-if="$root.template === 'video_template'" autoplay muted playsinline preload="auto"
                       :src="$root.hotel.main_video" loop
                       class="object-cover w-full h-screen-calc">
                    Your browser does not support the video tag.
                </video>
                <a-carousel class="h-screen-calc w-full" effect="fade" :dots="false" autoplay
                            v-if="$root.template === 'slider_template'">
                    <div class="bg-carousel-hotel object-cover bg-cover absolute top-0 left-0 w-full h-screen z-[6]"
                         v-if="sliders[0] !== undefined"
                         :style="'background-image: url(' + $root.getImage($root.getImage(sliders[0])) + ')'">
                    </div>
                    <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[5]"
                         v-if="sliders[1] !== undefined"
                         :style="'background-image: url(' + $root.getImage($root.getImage(sliders[1])) + ')'">
                    </div>
                    <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[4]"
                         v-if="sliders[2] !== undefined"
                         :style="'background-image: url(' + $root.getImage($root.getImage(sliders[2])) + ')'"></div>
                    <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[3]"
                         v-if="sliders[3] !== undefined"
                         :style="'background-image: url(' + $root.getImage($root.getImage(sliders[3])) + ')'"></div>
                    <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[2]"
                         v-if="sliders[4] !== undefined"
                         :style="'background-image: url(' + $root.getImage($root.getImage(sliders[4])) + ')'"></div>
                </a-carousel>

                <div class="bg-gradient-to-b from-[#00000075] p-[10px] to-transparent flex items-center h-screen-calc justify-between flex-col absolute top-0 left-0 w-full get-screen" id="screen">
                    <div class="flex flex-col w-full items-center">
                        <div class="flex justify-between w-full p-[10px]">
                            <p class="flex items-center text-[#fff] text-[16px]">
                                <span class="pr-2">{{ crntDate }}</span> | <span class="px-2">{{ crntTime }}</span> |
                                <span class="px-2">{{ correctWeather }}°C</span>
                            </p>
                            <select-language class="mx-4"></select-language>
                        </div>
                        <img class="max-w-[250px] mt-[50px]" :src="$root.getImage($root.hotel.logo_main_page)" alt="">
                        <p class="text-[#fff] mt-3 text-center">{{ $root.getLangText($root.hotel.template_subtitle) }}</p>
                    </div>
                    <div id="bottom-buttons" class="absolute w-full bottom-9 px-[10px]">
                        <button v-if="$root.hotel.is_button_scroll" class="bg-[#ffffff99] rounded-full relative w-full p-1 flex justify-end mb-4 " :style="'color:' + $root.hotel.color" @click="goToMain">
                            <span class="text-[24px] font-[500] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                                  >{{ $root.getKeyWord('get_started') }}</span>
                            <svg width="69" height="69" viewBox="0 0 69 69" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="34.5" cy="34.5" r="34.5" :fill="$root.hotel.color"/>
                                <path d="M35 24.3334L35 45.6667M35 45.6667L43 37.6667M35 45.6667L27 37.6667"
                                      stroke="white"
                                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>

                        <div class="mb-4" id="scroll-down" v-if="!$root.hotel.is_button_scroll" @click="goToMain">
                            <span class="arrow-down"></span>
                            <span id="scroll-title">
                                <span v-if="$root.currentLanguage == 'ru'">Прокрутите вниз</span>
                                <span v-else-if="$root.currentLanguage == 'fr'">Parcourir</span>
                                <span v-else>Scroll down</span>
                            </span>
                        </div>
                    </div>                    
                </div>
                <div id="bottom-first-screen"></div>
            </div>
            <div class="relative flex-grow min-h-screen flex flex-col overflow-hidden">
                <div id="main" class="items-center">
                    <app-header></app-header>
                    <div >
                        <TopBanner></TopBanner>
                    </div>
                    <div class=" w-full min-h-[230px] mt-[30px]">
                        <app-sections></app-sections>
                    </div>
                    <div class="slide-banner pl-1 pr-1 pb-3 rounded p-3 slide-banner">
                        <div >
                            <app-banner></app-banner>
                        </div>
                    </div>
                    <app-social></app-social>
                    <app-footer></app-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopBanner from "../../components/article/TopBanner";
import AppSections from "../../components/article/AppSections.vue";
import AppSocial from "../../components/layout/AppSocial";
import AppBanner from "../../components/article/AppBanner";
import ArticleExtraPopup from './../Product/ArticleExtraPopup';
import {eventBus} from '../../main';
import AppHeader from "@/components/layout/header/AppHeader.vue";
import selectLanguage from "@/components/layout/header/ArticleSelectLang.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import {dragscroll} from 'vue-dragscroll';


export default {
    name: "HomeNew",

    components: {
        AppFooter,
        selectLanguage, AppHeader, TopBanner, AppSections, AppBanner, AppSocial, ArticleExtraPopup
    },

    directives: {
        dragscroll
    },

    data() {
        return {
            documentClientHeight: document.documentElement.clientHeight,
            isDraging: false,
            startPosition: 0,
            scrollLeft: 0,
            newPosition: 0,
            distance: 0,
            startY: 0,
            template: this.$root.template,
            lockScroll: false,
            crntTime: '',
            crntDate: '',
        }
    },

    mounted() {
        window.scrollTo(0, 0);

        /* remove div.overlist from dom on Back Button if exists */
        if (document.getElementsByClassName('overlist')[0] !== undefined) {
            let elem = document.getElementsByClassName('overlist')[0];
            elem.parentNode.removeChild(elem);
        }

        setInterval(function () {
            this.currentDate();
            this.currentTime();
        }.bind(this), 2000);

        document.getElementById('home-screen-index').addEventListener('scroll', this.handleScroll);

        if (localStorage.getItem('is_second_screen') === 'true') {
            document.getElementById('home-screen-index').scrollTop = document.getElementById('main-screen-index').offsetHeight + 20;
        }
    },

    beforeDestroy() {
        // Remove the event listener when the component is about to be destroyed
        if(document.getElementById('home-screen-index')) {
            document.getElementById('home-screen-index').removeEventListener('scroll', this.handleScroll);
        }
    },

    created() {
        this.$nextTick(() => {
            const elements = document.querySelectorAll('.home-d');
            elements.forEach(el => {
                // Remove 'wrapper' class if it exists
                if (el.classList.contains('wrapper')) {
                    el.classList.remove('wrapper');
                }
                // Remove 'container' class if it exists
                if (el.classList.contains('container')) {
                    el.classList.remove('container');
                }
            });

            eventBus.$on('navigation-menu-uploaded', data => {
                if (localStorage.getItem('is_second_screen') === 'true' || this.$route.name !== 'home') {
                    document.getElementById('bottom-navigation').classList.add('bottom-0');
                    document.getElementById('bottom-navigation').classList.remove('bottom-[-100px]');
                } else {
                    // console.log(document.getElementById('bottom-navigation'));
                    document.getElementById('bottom-navigation').classList.add('bottom-[-100px]');
                    document.getElementById('bottom-navigation').classList.remove('bottom-0');
                }
            });



        });
        // console.log(localStorage.getItem('is_second_screen') === 'true');

    },

    methods: {
        handleScroll() {
            // The scroll event doesn't provide the current scroll position,
            if (document.getElementById('home-screen-index').scrollTop >= document.getElementById('main-screen-index').offsetHeight) {
                document.getElementById('bottom-navigation').classList.add('bottom-0');
                document.getElementById('bottom-navigation').classList.remove('bottom-[-100px]');
                this.showAnnouncement();
                localStorage.setItem('is_second_screen', true);
            } else {
                document.getElementById('bottom-navigation').classList.remove('bottom-0');
                document.getElementById('bottom-navigation').classList.add('bottom-[-100px]');
                localStorage.setItem('is_second_screen', false);
            }
        },
    
        goToMain() {
            document.getElementById("main").scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        
        currentDate() {
            let today = new Date();
            let timezone = this.$root.hotel.ext_data.timezone.replace('posix/', '');
            let locale = '';
            locale = process.env.VUE_APP_SERVER.toLowerCase() === 'ca' ? 'en-EN' : 'ru-RU';
            today = today.toLocaleDateString(locale, {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                timeZone: timezone
            });

            if (locale === 'ru-RU') {
                today = today.replaceAll('.', '\u00B7');
            }
            else {
                today = today.replaceAll('/', '\u00B7');
            }
            this.crntDate = today;
        },

        currentTime() {
            let time = new Date();
            let timezone = this.$root.hotel.ext_data.timezone.replace('posix/', '');
            if (process.env.VUE_APP_SERVER.toLowerCase() === 'ru') {
                time = time.toLocaleString('ru-RU', {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false,
                    timeZone: timezone
                });
            } else {
                time = time.toLocaleString('en-EN', {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                    timeZone: timezone
                });
            }

            this.crntTime = time;
        },

        showAnnouncement() {
            if (this.$root.show_announce === false && location.pathname.indexOf('/products') < 0 && location.pathname.indexOf('/sections') < 0) {
                eventBus.$emit('modal-announcement', {
                    parent_section_id: null,
                });
                this.$root.show_announce = true;
            }

            this.announcement = false;
        }
    },

    computed: {
        sliders() {
            return JSON.parse(this.$root.hotel.template_sliders);
        },

        correctWeather() {
            let weather = this.$root.weather.substring(0, this.$root.weather.indexOf('.'));
            return weather[0] === '-' ? weather.substr(0, 3) : weather.substr(0, 2);
        }
    }
}

</script>

<style>
::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    display: none
}

#wrapper {
    transition: all 0.9s ease-in-out;
}

#bottom-navigation {
    transition: all 0.4s ease-in-out;
}

.ant-carousel .slick-slide {
    text-align: center;
    height: 100vh;
    line-height: 160px;
    background: #364d79;
    overflow: hidden;
}

.bg-carousel-hotel {
    background-size: cover;
    background-position: center;
}

#main {
    clip-path: inset(0 0 30px 0);
    padding-bottom: 30px;
}

.h-screen-calc {
    height: 100vh;
    height: calc(var(--vh, 1vh)*100);
}

.layout {
    height: 100vh;
    height: calc(var(--vh, 1vh)*100);
    width: 100vw;
    max-width: 100%;
}

.ant-carousel .slick-list {
    height: 100vh;
    height: calc(var(--vh, 1vh)*100);
}
</style>